import { GLServiceBase, ServiceRoute } from "@/commonui/services";
import { DetailsReportTagListModel, TagAssociationDetails } from "@/models/details-report-model";

class DetailsReportServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getContentTagList(params: any): Promise<DetailsReportTagListModel[]> {
		return this.request.get(this.url("contenttaglist"), {
			params
		});
	}

	getContentTextReport(params?: any): Promise<TagAssociationDetails[]> {
		return this.request.get(this.url("contenttextreport"), {
			params
		});
	}
}

export const DetailsReportService = new DetailsReportServiceClass();
